import React, {useState} from 'react';
import {Card, CardActions, CardContent} from "@mui/material";
import {CardData, CardTitle, ImageDialog} from "@atttomyx/react-components";
import {cloudinary, datetime, formatters, strings} from "@atttomyx/shared-utils";
import {renderRanks} from "../../utils/ranks";
import {PLACEHOLDER_LANDSCAPE} from "../../constants";
import "./courseCard.css";

const ellipsis = (str, max) => str && str.length > max
    ? str.slice(0, max) + "..."
    : str;

const CourseCard = (props) => {
    const { course, filters, children } = props;
    const [showDialog, setShowDialog] = useState(false);

    return <Card className="course-card" raised={true}>
        <CardContent>
            <CardTitle>
                <img
                    className="course"
                    alt={course.name}
                    src={course.imageUrl ? cloudinary.trim(course.imageUrl) : PLACEHOLDER_LANDSCAPE}
                    onClick={() => setShowDialog(strings.isNotBlank(course.imageUrl))}
                />
            </CardTitle>
            <CardData
                filters={filters}
                data={course}
                keyToMetadata={{
                    name: {
                        title: "Name",
                    },
                    description: {
                        title: "description",
                        formatter: (data) => ellipsis(data, 40),
                    },
                    numFiles: {
                        title: "Files",
                        getter: (data) => data.documentIds ? data.documentIds.length : 0,
                    },
                    numVideos: {
                        title: "Videos",
                        getter: (data) => data.videoIds ? data.videoIds.length : 0,
                    },
                    numQuestionnaires: {
                        title: "Forms",
                        getter: (data) => data.questionnaireIds ? data.questionnaireIds.length : 0,
                    },
                    numPrerequisiteIds: {
                        title: "Prerequisites",
                        getter: (data) => data.prerequisiteIds ? data.prerequisiteIds.length : 0,
                    },
                    numTemplates: {
                        title: "Templates",
                        getter: (data) => data.templateIds ? data.templateIds.length : 0,
                    },
                    numUpsells: {
                        title: "Upsells",
                        getter: (data) => data.upsellIds ? data.upsellIds.length : 0,
                    },
                    music: {
                        title: "Music",
                        formatter: formatters.booleanToString,
                    },
                    ranks: {
                        title: "Ranks",
                        formatter: renderRanks,
                    },
                    status: {
                        title: "Status",
                        className: "status " + course.status,
                    },
                    order: {
                        title: "Index",
                    },
                    created: {
                        title: "Created",
                        formatter: datetime.getFullDateAndTime,
                    },
                    updated: {
                        title: "Updated",
                        formatter: datetime.getFullDateAndTime,
                    },
                }}
            />
        </CardContent>
        <CardActions disableSpacing={true}>
            {children}
        </CardActions>
        {showDialog ?
            <ImageDialog
                title={course.name}
                imageUrl={course.imageUrl}
                onCancel={() => setShowDialog(false)}
            /> : null}
    </Card>
}

export default CourseCard;
